import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify } from 'qs';

import TrackItem from '../../../components/TrackItem';
import { BuyTrackButton } from '../../../components/BuyButton/BuyButton';
import { DownloadTrackButton } from '../../../components/DownloadButton';
import SheetTitle from '../../../components/SheetTitle';

import c from './TracksBlock.less';

function TracksBlock({
  q, items, standalone, total,
}) {
  return (
    <div>
      <SheetTitle
        title="Tracks"
        rightBlock={
          !standalone && total > 6 ? (
            <Link to={`/search/tracks?${stringify({ q })}`}>Show more</Link>
          ) : null
        }
      />
      <div>
        {
          items.map((track) => (
            <TrackItem
              showLinkToRelease
              showLinkToArtist
              showRelease
              key={track.id}
              artist={track.artist}
              track={track}
              actions={
                track.downloadUrl ? (
                  <DownloadTrackButton
                    className={c.downloadTrackButton}
                    url={track.downloadUrl}
                    fileSize={track.fileSize}
                    wasDownloaded={!!track.lastDownloadedTime}
                  />
                ) : (
                  <BuyTrackButton track={track} alt={`Buy ${track.name} mp3 song by ${track.artist.name}`} />
                )
              }
            />
          ))
        }
      </div>
    </div>
  );
}

TracksBlock.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  q: PropTypes.string.isRequired,
  standalone: PropTypes.bool,
};

TracksBlock.defaultProps = {
  items: [],
  total: 0,
  standalone: false,
};

export default TracksBlock;
